export default __webpack_public_path__ + "static/our-team-tablet-1-d1eab81521cc673fb84c3660ebf1bc66.png";